import { styled } from "styled-components";

const SectionTitle = ({ title }: { title: string }) => {
  return <StyledSectionTitle>{title}</StyledSectionTitle>;
};

const StyledSectionTitle = styled.h2`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.primaryText};
  text-transform: uppercase;
`;

export default SectionTitle;
